import { Base } from 'src/api/Base'

export class ReportBuilderAPI extends Base {
  static get entity() {
    return 'reports-builder'
  }

  static async getReportsList() {
    const { dealerGroupId } = this.datepicker
    const params = {
      dealerGroupId,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
    }).get(`/${this.entity}/index`, { params })
    return data
  }

  static async getPresetsList() {
    const { data } = await this.request({ shouldCancelOnRoute: false }).get(
      `/${this.entity}/presets`
    )
    return data
  }

  static async getReportView({ id }) {
    const params = {
      id,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
    }).get(`/${this.entity}/view`, { params })

    if (data.reportSettings === null) {
      data.reportSettings = { pages: [] }
    }

    if (data.task !== null) {
      if (data.task.cronDayOfWeek !== '*') {
        data.task.cronDayOfWeek = data.task.cronDayOfWeek.split(',')
      }
      if (data.task.cronDay !== '*' && !data.task.cronDay.startsWith('*/')) {
        data.task.cronDay = data.task.cronDay.split(',')
      }
    }

    return data
  }

  static async getFile({ id, fileType, percentages = false, comparison, dealerships }) {
    const options = this.normalizeOptions({
      percentages: Number(percentages),
      comparison,
    })
    const params = {
      id,
      ...this.datepicker,
      ...options,
      dealerShipId: dealerships.join(','),
    }
    const { data } = await this.request({
      shouldCancelOnGet: false,
    }).get(`/${this.entity}/${fileType}`, { params })
    return data
  }

  static async createReport({
    title,
    isDraft,
    isPrivate,
    dealerGroupId = this.datepicker.dealerGroupId,
  }) {
    const body = {
      title,
      isDraft: Number(isDraft),
      isPrivate: Number(isPrivate),
      dealerGroupId,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/create`, body)
    return data
  }

  static async updateReport({
    id,
    isDraft,
    isPrivate,
    title,
    reportSettings,
    dealerGroupId = this.datepicker.dealerGroupId,
  }) {
    const body = {
      title,
      isDraft: Number(isDraft),
      isPrivate: Number(isPrivate),
      reportSettings,
      dealerGroupId,
    }
    const params = {
      id,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/update`, body, { params })
    return data
  }

  static async deleteReport({ id }) {
    const params = {
      id,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/delete`, {}, { params })
    return data
  }

  static async cloneReport({
    id,
    title,
    isDraft,
    isPrivate,
    dealerGroupId = this.datepicker.dealerGroupId,
  }) {
    const body = {
      id,
      title,
      isDraft: Number(isDraft),
      isPrivate: Number(isPrivate),
      dealerGroupId,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/clone`, body)
    return data
  }

  static async upload({ file, onUploadProgress }) {
    const formData = new FormData()
    formData.append('uploadedFile', file)

    const { data } = await this.request({ shouldCancelOnGet: false }).post(
      `/${this.entity}/upload`,
      formData,
      {
        onUploadProgress, // optional
      }
    )
    return data
  }

  static async deleteImg({ awsFileKey }) {
    const params = {
      awsFileKey,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/remove-img`, {}, { params })
    return data
  }
}
